import { RequestCommentTypeEnum } from '@omnea-app/packages/universal/hasura/graphql'
import { useInsertRequestComment } from './useInsertRequestComment'
import { useRefetchForms } from './useRefetchForms'
import type { UploadedFile } from '../uploadedFile'

export type AmendmentRequestInput = {
  message: string
  files?: UploadedFile[]
  questionTitle?: string
}

export const useRequestAmendment = ({ requestId }: { requestId: string }) => {
  const { mutateAsync: insertRequestComment, isPending } = useInsertRequestComment({ requestId })
  const refetchForms = useRefetchForms()

  const requestAmendment = async (
    { requestFormId, questionId }: { requestFormId: string; questionId: string },
    amendmentRequestInput: AmendmentRequestInput
  ) => {
    await insertRequestComment({
      requestId,
      requestFormId,
      questionId,
      payload: {
        text: amendmentRequestInput.message,
        questionTitle: amendmentRequestInput.questionTitle,
        files: amendmentRequestInput.files || [],
      },
      type: RequestCommentTypeEnum.AMENDMENT_REQUEST,
    })
    await refetchForms({
      requestId,
      requestFormId,
    })
  }

  return { requestAmendment, isPending }
}
